
// src/reducers/upload-file-reducer.js

import { mergeArray, deleteArray } from '../helpers/store'
import cloneDeep from 'lodash/cloneDeep'
import merge from 'lodash/merge'

import { 
  UPLOAD_FILE,
  UPLOAD_FILE_REQUESTED,
  UPLOAD_FILE_COMPLETED,
  UPLOAD_FILE_FAILED,
  UPLOAD_FILE_PROGRESS,
  CANCEL_UPLOAD_FILE,
  CLEAR_UPLOAD_FILES_AND_VIDEOS,
} from '../actions/upload-file'

const initialState = {
}

export default function uploadFileReducer(state = initialState, action = {}) {
  switch(action.type) {
  case UPLOAD_FILE_REQUESTED:
    return merge(cloneDeep(state), {
      [action.componentId]: {
        [action.uploadId]: {
          isUploading: true,
          loaded: null,
          total: null,
          single: action.single,
        }
      }
    })

  case UPLOAD_FILE_FAILED:
    return merge(cloneDeep(state), {
      [action.componentId]: {
        [action.uploadId]: null
      }
    })

  case UPLOAD_FILE_COMPLETED:
    if (action.single)
      return Object.assign({}, state, {
        [action.componentId]: {
          [action.uploadId]: {
            isUploading: false,
            item: action.results,
            loaded: null,
            total: null,
          }
        }
      })
    else
      return merge(cloneDeep(state), {
        [action.componentId]: {
          [action.uploadId]: {
            isUploading: false,
            item: action.results,
            loaded: null,
            total: null,
          }
        }
      })

  case UPLOAD_FILE_PROGRESS:
    return merge(cloneDeep(state), {
      [action.componentId]: {
        [action.uploadId]: {
          isUploading: true,
          loaded: action.loaded,
          total: action.total,
        }
      }
    })

  case CANCEL_UPLOAD_FILE:
    return merge(cloneDeep(state), {
      [action.componentId]: {
        [action.uploadId]: null
      }
    })

  case CLEAR_UPLOAD_FILES_AND_VIDEOS:
    return Object.assign({}, state, { [action.componentId]: undefined })

  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/upload-file-reducer.js